import Klaviyo from './services-klaviyo.js';

class ProductStockNotification extends HTMLElement {
  constructor() {
    super();

    this.submitButton = this.querySelector('[data-notify-submit]');

    this.emailInput = this.querySelector('input[type="email"]');
    this.emailValue;
    this.emailConsent;

    this.variantId = this.dataset.variantId;

    this.successElement = this.querySelector('[data-notify-success]');
    this.errorElement = this.querySelector('[data-notify-error]');
  }

  connectedCallback() {
    this.submitButton.onclick = async (event) => await this.handleSubmit(event);

    // Listen to the variant change event
    document.addEventListener('variant-change', this.handleAfterVariantChange.bind(this));
  }

  /**
   * Called when the variant changes.
   * @param {Object} event.detail The event detail.
   */
  handleAfterVariantChange({ detail }) {
    const id = detail?.variant.id;
    if (!id) return;
    this.variantId = id;
  }

  /**
   * Toggles the loading state of the submit button.
   * @param {Boolean} loading Whether the button is loading.
   * @returns {Boolean} Whether the button is loading.
   */
  isLoading(loading) {
    this.submitButton.classList.toggle('loading', loading);
    this.submitButton.disabled = loading;
    return loading;
  }

  /**
   * Handles the form submission.
   * @param {Event} event The form submission event.
   */
  async handleSubmit(event) {
    event.preventDefault();

    this.isLoading(true);
    this.toggleErrorMessage(false);

    this.emailValue = this.emailInput.value;

    // Set the email consent
    this.emailConsent = this.querySelector('input[type="checkbox"]')?.checked;

    try {
      // Try to create the BIS subscription first
      await Klaviyo.createClientBackInStockSubscription({
        email: this.emailValue,
        variantId: this.variantId,
      });

      // If successful, create the client subscription
      if (this.emailConsent) {
        const profileProperties = {};
        const interest = this.querySelector('marketing-input')
          ?.getAttribute('interests')
          ?.split(',');

        if (interest) profileProperties.brandPreference = interest;

        await Klaviyo.createClientSubscription({
          customSource: 'Back In Stock',
          email: this.emailValue,
          profileProperties,
        });
      }

      this.successElement.classList.remove('hidden');
    } catch (error) {
      this.toggleErrorMessage(true, error.message);
    } finally {
      this.isLoading(false);
    }
  }

  /**
   * Toggles the error message.
   * @param {Boolean} show Whether to show the error message.
   * @param {String} message The error message.
   */
  toggleErrorMessage(show, message = '') {
    this.errorElement.classList.toggle('hidden', !show);
    this.errorElement.textContent = message;
  }
}

if (!customElements.get('product-stock-notification')) {
  window.ProductStockNotification = ProductStockNotification;
  customElements.define('product-stock-notification', ProductStockNotification);
}
